import { ProjectType } from '@/schema'

// API Endpoints
export const API_ENDPOINT_PROJECTS = '/admin/v1/projects'

// Validation Limits
export const MAX_REPORTING_EVENTS = 25

// Query Keys
export const QUERY_KEY_PROJECT_LIST = 'project-list'
export const QUERY_KEY_PROJECT_DETAIL = 'project-detail'

export const PROJECT_LIST_QUERY_KEY = (params: (string | number)[]) => [
  QUERY_KEY_PROJECT_LIST,
  ...(params ? [params] : []),
]
export const PROJECT_DETAIL_QUERY_KEY = (id: string | number) => [
  QUERY_KEY_PROJECT_DETAIL,
  id,
]

// Stale Time
export const PROJECT_DETAIL_STALE_TIME = 5 * 60 * 1000

export const PROJECT_TYPE_OPTIONS: { label: string; value: ProjectType }[] = [
  { label: 'project.type.ascendSpark', value: ProjectType.ASCEND_SPARK },
  { label: 'project.type.standalone', value: ProjectType.STANDALONE },
]
